import React from "react";
import { TableContentForMasterCardTagReport } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const tableHeaders = this.props.tableHeaders;
        const footerTotal = this.props.footerTotal;

        return (
            <div>
                <h3><center><u>Master Card Leaf Collection Tag Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Collection Type: </b> {searchData.collectionType === undefined ? "All Collection Types"
                        : searchData.collectionType}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="pdfTable" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        {
                                            tableHeaders.map((x, index) => {
                                                return (
                                                    <th key={index}>{x}</th>
                                                );
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForMasterCardTagReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr style={{ fontWeight: "bold" }}>
                                        <th >Total</th>
                                        {footerTotal.map((x, index) => {
                                            return (
                                                <th key={index}>{x.total}</th>
                                            );
                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}